'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../../i-bem/i-bem.react');

var _bIServices = (require('./../../i-services/i-services.react.js').default || require('./../../i-services/i-services.react.js')).applyDecls();

var _bIServices2 = _interopRequireDefault(_bIServices);

var _ePresets = (require('./../__presets/tableau-node__presets.react.js').default || require('./../__presets/tableau-node__presets.react.js')).applyDecls();

var _ePresets2 = _interopRequireDefault(_ePresets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_PRESET = 'ru';

exports.default = (0, _iBem.decl)({
    block: 'tableau-node',
    elem: 'links',
    render: function render() {
        var _props = this.props,
            preset = _props.preset,
            query = _props.query,
            queryParams = _props.queryParams;


        return this.__self.getLinks(preset, query, queryParams);
    }
}, {
    _fixQueryParams: function _fixQueryParams(serviceId, queryParams) {
        queryParams = _extends({}, queryParams);

        if (queryParams.serviceId && !queryParams.clid && serviceId === 'market') {
            queryParams.clid = {
                www: 505,
                search: 521,
                images: 526
            }[queryParams.serviceId] || 52;
        }

        return queryParams;
    },
    _getUrl: function _getUrl(mainUrl, searchParams, query, queryParams) {
        if (!query) {
            return mainUrl;
        }

        var url = new URL.parse(mainUrl);
        var path = searchParams.path;
        if (path) {
            url.pathname = path;
        }

        var params = searchParams.params;
        if (params) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(params)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    var value = params[key];
                    value = value.replace('%s', query);

                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = Object.keys(queryParams)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var qkey = _step2.value;

                            value = value.replace('${' + qkey + '}', queryParams[qkey]);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    value = value.replace(/\$\{[^}]*\}/g, '');

                    url.query = url.query || {};
                    url.query[key] = value;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        return url.format();
    },
    getLinks: function getLinks(preset, query, queryParams) {
        var data = _ePresets2.default.data;
        var searchData = _ePresets2.default.searchData;
        preset = data[preset] || data[DEFAULT_PRESET];

        var res = [];

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = preset.services[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var serviceId = _step3.value;

                var serviceUrl = _bIServices2.default.serviceUrl(serviceId);
                var title = _bIServices2.default.serviceName(serviceId);

                var qp = this._fixQueryParams(serviceId, queryParams);
                var url = this._getUrl(serviceUrl, searchData[serviceId] || {}, query, qp);

                res.push(_react2.default.createElement(
                    _iBem.Bem,
                    { key: serviceId, tag: 'a', attrs: { href: url } },
                    title
                ));
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        return res;
    },


    defaultProps: {
        preset: DEFAULT_PRESET
    }
});